// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class LeavePolicy  {
    _originalTypeClassName = "Loom.BO.LeavePolicy";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
LeavePolicy.translate = translateService;
}
this.Id = null;
this.MaxAllowableDays = null;
this.Carryover = false;
this.MaxCarryoverLimit = null;
this.NumberOfApprovalsNeeded = null;
this.RequiresApproval = true;
this.RequiresEvidence = false;
this.Caption = null;
this.HasUnlimitedQuota = false;
this.AllowsHalfDays = false;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
MaxAllowableDays:any;
Carryover:any;
MaxCarryoverLimit:any;
NumberOfApprovalsNeeded:any;
RequiresApproval:any;
RequiresEvidence:any;
Caption:any;
HasUnlimitedQuota:any;
AllowsHalfDays:any;
Country:any;
TypeOfLeave:any;
Organisation:any;
static setCountry = ($this, value) => {
var oldValue = $this.Country;
$this.Country = value;
if (value != null) {
}
}
static setTypeOfLeave = ($this, value) => {
var oldValue = $this.TypeOfLeave;
$this.TypeOfLeave = value;
if (value != null) {
}
}
static setOrganisation = ($this, value) => {
var oldValue = $this.Organisation;
$this.Organisation = value;
if (value != null) {
}
}

static GetCaption($this: any): any{return $this?.TypeOfLeave?.Name + " - " + $this?.Organisation?.ShortName + " - " + $this?.Country?.ISOCode2;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}